import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-logo",
  "use": "facebook-logo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook-logo\"><path d=\"M15.81 3.985h2.191V.169C17.623.117 16.323 0 14.809 0 11.65 0 9.486 1.987 9.486 5.639V9H6v4.266h3.486V24h4.274V13.267h3.345l.531-4.266h-3.877V6.062c.001-1.233.333-2.077 2.051-2.077z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id